import type { PartnerPackagingV2, PartnerPackagingV2Set } from '@shipium-corp/shipium-ts-types';
import { Form, Input, Select, Typography } from 'antd';
import type { FormInstance } from 'antd/lib/form';
import { type FormProps } from 'antd/lib/form';
import { useEffect } from 'react';

const { Paragraph } = Typography;

export interface PackagingSetFormProps {
  form: FormInstance;
  activePartnerPackagingSet?: PartnerPackagingV2Set;
  partnerPackaging: PartnerPackagingV2[];
}

export const PackagingSetForm = ({
  form,
  activePartnerPackagingSet,
  partnerPackaging,
  ...props
}: PackagingSetFormProps & FormProps) => {
  const handleCancelClick = () => {
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue({
      name: activePartnerPackagingSet?.name,
      description: activePartnerPackagingSet?.description,
      packagingIds: activePartnerPackagingSet?.packagingIds,
      partnerProvidedId: activePartnerPackagingSet?.partnerProvidedId,
    });
  }, [activePartnerPackagingSet, form]);

  return (
    <Form form={form} onReset={handleCancelClick} layout={'vertical'} wrapperCol={{ span: 20, offset: 1 }} {...props}>
      {activePartnerPackagingSet && (
        <Form.Item label={<b>Packaging Set ID</b>} style={{ marginBottom: 10 }} name="packagingSetId">
          <Paragraph copyable>{activePartnerPackagingSet?.packagingSetId}</Paragraph>
        </Form.Item>
      )}

      <Form.Item
        label={<b>Name</b>}
        style={{ marginBottom: 10 }}
        name="name"
        rules={[{ required: true, message: 'Name is required' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={<b>Description</b>}
        style={{ marginBottom: 10 }}
        name="description"
        rules={[{ required: false }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={<b>Packaging Set ID Alias</b>}
        style={{ marginBottom: 10 }}
        name="partnerProvidedId"
        help="You may optionally define this ID, and it can be used in lieu of the Shipium generated Packaging Set ID."
      >
        <Input />
      </Form.Item>

      {partnerPackaging && (
        <Form.Item name={'packagingIds'} label={<b>Select Packaging Options</b>}>
          <Select mode="multiple">
            {partnerPackaging
              .filter((p) => p.active === true)
              .map((p: PartnerPackagingV2) => (
                <Select.Option key={p.packagingId} value={p.packagingId}>
                  {String(p?.name)}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      )}
    </Form>
  );
};
